export const getters = {
    list: state => state.list,
    dateList: state => state.dateList,
    patientHistoryList: state => state.patientHistoryList,
    
    inventory: state => state.inventory,
    columns: state => state.columns,
    model: state => state.model,
    filter: state => state.filter,
    pagination: state => state.pagination,
    sort: state => state.sort,
    rules: state => state.rules,
};
